<template>
	<div
		ref="planning"
		@click="openPlanning"
		class="planning">
		<div class="planning__top">
			<Icon
				:icon="icon">
			</Icon>
			<div class="planning__top__info">
				<h2 class="planning__top__info__title">{{title}}</h2>
				<p v-if="!userIsOwner">
					{{owner.username}}
					<i v-if="ownerIsFriend && page === 'explore'" class="far fa-star friend"></i>
				</p>
				<p v-if="openTasks > 0 && page === 'plannings'" class="planning__top__info__tasks">
					<span v-if="openTasks > 1">{{openTasks}} open tasks</span>
					<span v-else-if="openTasks === 1">1 open task</span>
				</p>
				<p v-if="page==='explore'" class="planning__top__info__replicate_amount">
					<span v-if="replicate_amount === 1">Replicated 1 time</span>
					<span v-else>Replicated {{replicate_amount}} times</span>
				</p>
			</div>
		</div>
		<div class="planning__footer">
			<div
				class="planning__footer__progress"
				v-if="page==='plannings'">
				<Progress
					:tasks="tasks">
				</Progress>
			</div>
		</div>
	</div>
</template>

<script>
import PlanningService from '@/services/PlanningService'
import Icon from '@/components/Icon.vue'
import Progress from '@/components/Progress.vue'
export default {
	components: {
		Icon,
		Progress
	},
	props: {
		id: Number,
		title: String,
		icon: String,
		owner: Object,
		tasks: Array,
		replicate_amount: Number,
		indexOnPage: Number
	},
	data () {
		return {
		}
	},
	methods: {
		openPlanning () {
			this.$router.push(`/planning/${this.id}`)
		}
	},
	computed: {
		page () {
			return this.$route.name
		},
		userIsOwner () {
			return this.owner.id === this.$store.state.authentication.user.id
		},
		darkMode () {
			return this.$store.state.settings.darkMode
		},
		openTasks () {
			return this.tasks ? PlanningService.getOpenTasks(this.tasks) : null
		},
		ownerIsFriend () {
			const friendNames = this.$store.state.social.friendNames
			if (!friendNames) return false
			return friendNames.includes(this.owner.username)
		}
	}
}
</script>

<style lang="scss" scoped>
@import "@/styles/components/_planning.scss";
.friend {
	@extend %label;
	@extend %label--primary;
	vertical-align: baseline;
}
</style>
